import { render, staticRenderFns } from "@/modules/ReportsRules/templates/reports-rules.html?vue&type=template&id=6f1fc0b0&scoped=true&"
import script from "@/modules/ReportsRules/scripts/reports-rules.ts?vue&type=script&lang=js&"
export * from "@/modules/ReportsRules/scripts/reports-rules.ts?vue&type=script&lang=js&"
import style0 from "@/modules/ReportsRules/styles/reports-rules.scss?vue&type=style&index=0&id=6f1fc0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1fc0b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VImg,VTooltip})
